/*!

=========================================================
* Now UI Dashboard React - v1.5.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import React from "react";
import ReactDOM from "react-dom";
import './index.css';
import "bootstrap/dist/css/bootstrap.css";
import './theme-overrides.css';
import "assets/scss/now-ui-dashboard.scss?v1.5.0";
import "assets/css/demo.css";
// import "assets/css/eve.css";
import "assets/css/chat.css";
import { Provider } from "react-redux";
import store from "./store/store";
import App from './App';

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
);